module.exports = __webpack_public_path__ + "img/travelService-video.362cf8a8.png";